/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { htmlspecialchars } from './util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';


/**
 * Show temporary information about an action that occured, or about an error state in the UI.
 *
 * @param {string} text
 * @param {...string} [link] optional URL & action of a link appended; optional text appended after link
 */
export function showSnackbar( text ) {
	if( mj.info_hook ) mj.info_hook(text);
	jQuery('#info')
		.detach()
		.html( htmlspecialchars(text) )
		.appendTo('body')
		.stop(true)
		.css( 'opacity', 0.95 )
		.slideDown( 300, function() {
			jQuery(this)
				.css('height','auto')
				.animate( {opacity:0.75}, 15000, '', function() {
					jQuery(this).fadeOut(1500);
				});
		} );
	if( arguments.length > 2 ) {
		jQuery('<a>')
			.addClass('link')
			.attr('href',arguments[1])
			.attr('target','_blank')
			.text(arguments[1])
			.click(arguments[2])
			.appendTo(jQuery('#info'));
		// optional: text after link
		if( arguments.length > 3 ) jQuery('<span>').text(arguments[3]).appendTo(jQuery('#info'));
	}
}


/**
 * Immediately hide the latest temporary action information text from UI.
 */
export function hideSnackbar() {
	jQuery('#info')
		.stop(true)
		.css( 'opacity', 0.0 );
}

